// extracted by mini-css-extract-plugin
module.exports = {"plugTitle":"Plug_plugTitle__jaNJd","plugContainer":"Plug_plugContainer__njtLs","plugDescription":"Plug_plugDescription__9ibem","btnGroup":"Plug_btnGroup__FVO9Z"};